'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RelativeLink = exports.useRelativeLinks = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

var _PatternUtils = require('react-router/lib/PatternUtils');

var _resolvePathname = require('resolve-pathname');

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useRelativeLinks = exports.useRelativeLinks = function useRelativeLinks() {
  return {
    renderContainer: function renderContainer(Component, props) {
      return _react2.default.createElement(RelativeLinksContainer, { Component: Component, routerProps: props });
    }
  };
};

var _React$PropTypes = _react2.default.PropTypes;
var oneOfType = _React$PropTypes.oneOfType;
var shape = _React$PropTypes.shape;
var object = _React$PropTypes.object;
var string = _React$PropTypes.string;
var func = _React$PropTypes.func;
var array = _React$PropTypes.array;


var relativeLinksContextType = {
  relativeLinks: shape({
    params: object.isRequired,
    route: object.isRequired,
    routes: array.isRequired
  }).isRequired
};

var RelativeLinksContainer = _react2.default.createClass({
  displayName: 'RelativeLinksContainer',


  propTypes: {
    Component: func.isRequired,
    routerProps: shape({
      route: object.isRequired,
      params: object.isRequired
    }).isRequired
  },

  childContextTypes: relativeLinksContextType,

  getChildContext: function getChildContext() {
    var _props$routerProps = this.props.routerProps;
    var params = _props$routerProps.params;
    var routes = _props$routerProps.routes;
    var route = _props$routerProps.route;

    return { relativeLinks: { params: params, route: route, routes: routes } };
  },
  render: function render() {
    var _props = this.props;
    var createElement = _props.createElement;
    var Component = _props.Component;
    var routerProps = _props.routerProps;

    return createElement(Component, routerProps);
  }
});

var isAbsolute = function isAbsolute(to) {
  return to.match(/^\//);
};

var constructRoutePattern = function constructRoutePattern(currentRoute, routes) {
  var fullPath = '';

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = routes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var route = _step.value;
      var path = route.path;


      if (path) {
        if (path[0] === '/') {
          fullPath = path;
        } else {
          // If the first path-ed route has no leading slash, then this will add it.
          if (fullPath[fullPath.length - 1] !== '/') {
            fullPath += '/';
          }

          fullPath += path;
        }
      }

      if (route === currentRoute) {
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return fullPath;
};

var resolvePathname = function resolvePathname(_ref) {
  var relativePath = _ref.relativePath;
  var route = _ref.route;
  var routes = _ref.routes;
  var params = _ref.params;

  var patternUpToRoute = constructRoutePattern(route, routes);
  // TODO: remove trailing slash hack
  // we add a slash cause it's SUPER WEIRD if we don't, should add an option
  // to history to always use trailing slashes to not do this and cause
  // confusion for people who actually know how browsers resolve urls :P
  var specialCase = relativePath.trim() === '';
  var slash = specialCase ? '' : '/';
  var resolvedPattern = (0, _resolvePathname2.default)('' + relativePath + slash, patternUpToRoute + '/');
  var withoutSlash = resolvedPattern.substring(0, resolvedPattern.length - 1);
  return (0, _PatternUtils.formatPattern)(withoutSlash, params);
};

var RelativeLink = exports.RelativeLink = _react2.default.createClass({
  displayName: 'RelativeLink',


  propTypes: {
    to: oneOfType([string, object]).isRequired
  },

  contextTypes: relativeLinksContextType,

  getInitialState: function getInitialState() {
    return { to: this.calculateTo(this.props) };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.to !== this.props.to) {
      this.setState({ to: this.calculateTo(nextProps) });
    }
  },
  calculateTo: function calculateTo(props) {
    var to = props.to;
    var _context$relativeLink = this.context.relativeLinks;
    var route = _context$relativeLink.route;
    var routes = _context$relativeLink.routes;
    var params = _context$relativeLink.params;

    var isLocationDescriptor = (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object';
    var relativePath = isLocationDescriptor ? to.pathname || '' : to;
    var resolved = isAbsolute(relativePath) ? relativePath : resolvePathname({ relativePath: relativePath, route: route, routes: routes, params: params });
    return isLocationDescriptor ? _extends({}, to, { pathname: resolved }) : resolved;
  },
  render: function render() {
    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { to: this.state.to }));
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-router-relative-links/lib/RelativeLinks.js
// module id = 171
// module chunks = 0 1